import { useForm } from '@inertiajs/vue3';
import { nextTick, reactive, ref, watch } from 'vue';

import {
    checkout_price_id,
    // getChechoutPriceId, 
    getChildCoupon,
    goToStep,
    resetCheckout,
    // setCheckoutPriceId
} from './Welcome';

import { locale } from '@/Localization.js';
import { loadLanguageAsync, getActiveLanguage, trans, transChoice } from 'laravel-vue-i18n';

export const offering = reactive({});
export const subscription = ref(null);
export const has_local_coupon = ref(null);
export const has_stripe_coupon = ref(null);
export const show_stripe_offers = ref(null);
export const payment_label = ref(null);
export const payment_labels = ref(null);

export const emit = ref(null);
export const updateSubscription = (prop, value) => {
    // console.debug('CheckoutForm.updateSubscription()');
    emit.value('updateSubscription', prop, value);

    buildLabels();
};
export const reloadOffering = (code, callback) => {
    // console.debug('CheckoutForm.reloadOffering()');
    emit.value('reloadOffering', code, callback)
}

export const stripe_price_id = ref('');

export const form = useForm({
    success_url: '',
    cancel_url: '',
    lookup_key: '',
    duration: '',
});

export const number_format = (
    num,
    decimals = 0,
    decimal_separator = ".",
    thousands_separator = ",") => {
    return window.number_format(num, decimals, decimal_separator, thousands_separator);
};

export const submit = (force, totalCalls) => {

    if (!totalCalls) {
        totalCalls = 0;
    }

    if (form.processing) {
        return false;
    }

    // console.debug('CheckoutForm.submit()', {
    //     force: !!force,
    //     totalCalls: totalCalls,
    //     'form.lookup_key': form.lookup_key,
    //     isProcessing: isProcessing()
    // });

    if (!form.lookup_key && subscription.value.stripe_price_id) {
        form.lookup_key = subscription.value.stripe_price_id;
    }

    if (!form.lookup_key && stripe_price_id.value) {
        form.lookup_key = stripe_price_id.value;
    }

    if (!form.lookup_key && force) {
        // @see defaultLookupKey()
        if (has_stripe_coupon.value || Object.keys(sortable.value).length == 1) {
            var values = Object.values(sortable.value);
            if (values.length) {
                var defaultLk = values[0].stripe.id;

                if (defaultLk) {
                    form.lookup_key = defaultLk
                    stripe_price_id.value = defaultLk;
                    updateSubscription('stripe_price_id', defaultLk);
                }
            }
        }
    }

    if (!form.lookup_key) {
        console.error('form.lookup_key is empty!', {
            lookup_key: form.lookup_key,
            subscription: subscription.value.stripe_price_id,
            stripe_price_id: stripe_price_id.value,
            sortable: sortable.value,
            values: Object.values(sortable.value),
        });
        // alert('form.lookup_key is empty!');

        return false;
    }

    if (form.lookup_key != stripe_price_id.value) {
        stripe_price_id.value = form.lookup_key;
        updateSubscription('stripe_price_id', form.lookup_key);

        if (show_stripe_offers.value) {

            // Update labels to apply coupon.
            nextTick(() => {
                buildLabels();
            });

            // console.debug('NEW LABEL:', labels[form.lookup_key], {
            //     // 'show_stripe_offers': show_stripe_offers.value,
            //     // 'coupon': subscription.value.app_user_coupon_stripe
            //     //     ? JSON.parse(JSON.stringify(subscription.value.app_user_coupon_stripe.coupon))
            //     //     : null
            // });

            // console.debug('NEW LABEL:', labels[form.lookup_key]);
            updateSubscription('label', labels[form.lookup_key]);

            // return false; // debug
        }
        // else {
        //     console.debug('NEW LABEL?', 'No label if !show_stripe_offers', { show_stripe_offers: show_stripe_offers.value });
        // }
    }

    if (subscription.value.app_user_id
        && subscription.value.stripe_price_id
        && subscription.value.app_user_coupon_stripe) {
        force = true;
    }

    if (force) {
        for (var z in prices) {
            var price = prices[z];
            if (price.stripe['id'] == form.lookup_key) {
                form.duration = price.stripe['metadata']['duration'];
                if (!form.duration) {
                    form.duration = price.stripe['lookup_key'];
                }
            }
        }

        setTimeout(() => {
            form.post(route('checkout.session'), {
                onSuccess: (page) => {
                    if (totalCalls < 2) {
                        return submit(force, totalCalls + 1);
                    }

                },
                onFinish: (visit) => {
                    if (form.hasErrors) {
                        if (form.errors.app_user_id) {
                            console.error('form.errors.app_user_id is missing! Processing to Stripe arboted!', {
                                'subscription.value.app_user_id': subscription.value.app_user_id,
                                'form.errors': JSON.parse(JSON.stringify(form.errors))
                            });
                            updateSubscription('app_user_id', '');

                            // form.clearErrors();

                            return submit();
                        }
                        if (!form.errors.entitlement_already_subscribed) {
                            form.lookup_key = '';
                            stripe_price_id.value = null;

                            updateSubscription('stripe_price_id', '');
                            updateSubscription('label', '');
                        }
                    }

                    if (totalCalls < 2) {
                        return submit(force, totalCalls + 1);
                    }
                },
                onError: (errors) => {
                    console.error('onError', errors)
                    if (form.lookup_key) {
                        form.lookup_key = '';
                        stripe_price_id.value = null;
                        updateSubscription('stripe_price_id', '');
                        updateSubscription('label', '');
                    }
                },
            });

        }, 500);

        return false;
    }

    // return  { submit };
};

export const isProcessing = (type) => {
    if (type == 'checkout') {
        return form.processing
    }

    if (type == 'coupon') {
        return (getChildCoupon() && getChildCoupon().currentCoupon.processing);
    }

    return form.processing || (getChildCoupon() && getChildCoupon().currentCoupon.processing);
}

export const labels = reactive({});
export const buildLabels = () => {

    if (!offering.value || !offering.value.packages) {
        // console.debug('buildLabels() returns false')
        return false;
    }

    // nextTick(() => {
    setTimeout(() => {

        let coupon = subscription.value.app_user_coupon_stripe
            ? subscription.value.app_user_coupon_stripe.coupon
            : null;

        Object.assign(labels, {});

        // console.error('CheckoutForm.buildLabels(), offering.value.packages', JSON.parse(JSON.stringify(offering.value.packages.items)));
        // console.error('CheckoutForm.buildLabels(), offering.value.packages', JSON.parse(JSON.stringify(Object.keys(offering.value.packages.items))));

        for (var k of Object.keys(offering.value.packages.items)) {
            var item = offering.value.packages.items[k];
            for (var price of item.products.items) {
                if (typeof price.stripe != 'undefined') {

                    var unit_amount = price.stripe['unit_amount'];

                    var p1 = price.stripe['product'];
                    var p2 = subscription.value.app_user_coupon_stripe
                        && coupon.applies_to
                        ? coupon.applies_to.products
                        : [];

                    let duration = getDuration(price.stripe);
                    let message = '';

                    let coupon_off = '~0';
                    let price_discount = null;
                    let price_normal = unit_amount / 100;

                    if (p2.length == 0 || p2.includes(p1)) {
                        if (coupon && coupon.percent_off) {
                            coupon_off = `-${coupon.percent_off}\xa0%`;
                            unit_amount = unit_amount - (unit_amount / 100 * coupon.percent_off);
                            price_discount = unit_amount / 100;
                        }
                        if (coupon && coupon.amount_off) {
                            coupon_off = `-${number_format(coupon.amount_off / 100, 2, ',', ' ')}\xa0€`;
                            unit_amount = unit_amount - coupon.amount_off;
                            price_discount = unit_amount / 100;
                        }
                    }

                    price_normal = number_format(price_normal, 2, ',', ' ');
                    price_discount = number_format(price_discount, 2, ',', ' ');

                    // if (p2.length == 0 || p2.includes(p1)) {
                    //     console.error('_off?', {
                    //         p1: p1,
                    //         p2: JSON.parse(JSON.stringify(p2)),
                    //         'p2.includes(p1)': p2.includes(p1),
                    //         coupon: coupon,
                    //         price_normal: price_normal,
                    //         price_discount: price_discount,
                    //     })
                    // }

                    let label = [];
                    if (price.stripe['type'] == 'recurring') {
                        label.push(trans('Offre'));
                        label.push(number_format(unit_amount / 100, 2, ',', ' '));
                        label.push('€');
                        label.push('/');
                        label.push(priceRecurringIntervalToFr(price.stripe['recurring']['interval_count'], price.stripe['recurring']['interval']))
                    } else {
                        label.push(trans('Offre à'));
                        label.push(number_format(unit_amount / 100, 2, ',', ' '));
                        label.push('€');
                        if (duration) {
                            label.push(` pour ${duration}`);
                        }
                        message = label.join(' ');
                    }

                    if (true) {

                        if (!duration) {
                            // Wrong offer?
                            // console.error('duration is missing! (2)', duration, price.stripe);

                            // Test
                            if (price.stripe['type'] == 'recurring') {
                                duration = priceRecurringIntervalToFr(price.stripe['recurring']['interval_count'], price.stripe['recurring']['interval'], true);
                            }
                        }

                        if (payment_labels.value && Object.keys(payment_labels.value).length) {
                            var message_new = '';
                            // var is_recurring = offering.value.packages.items[0].products.items[0].stripe.recurring;
                            var is_recurring = price.stripe['type'] == 'recurring'; // typeof price.stripe.recurring == 'object';
                            if (parseFloat(price_discount) > 0) {
                                if (is_recurring) {
                                    message_new = payment_labels.value['subscription_with_coupon'];
                                } else {
                                    message_new = payment_labels.value['one_time_with_coupon'];
                                }
                            } else {
                                if (is_recurring) {
                                    message_new = payment_labels.value['subscription'];
                                } else {
                                    message_new = payment_labels.value['one_time'];
                                }
                            }
                        }

                        // console.debug('payment_labels?', message_new, {
                        //     price_normal: parseFloat(price_normal),
                        //     price_discount: parseFloat(price_discount),
                        //     is_recurring: is_recurring
                        // });

                        if (message_new) {
                            // console.error('message_new?', trans(message_new), {
                            //     labels: labels,
                            //     'form.lookup_key': form.lookup_key,
                            //     "price.stripe['id']": price.stripe['id'],
                            //     duration: duration,
                            //     coupon_off: coupon_off,
                            //     price_discount: price_discount,
                            //     price_normal: price_normal
                            // });
                            message_new = trans(message_new);

                            // updateSubscription('label', labels[form.lookup_key]);
                        }

                        if (message_new) {
                            label = [message_new];
                        }

                        message = label.join(' ');
                        message = message.replace(/\$\{duration\}/, duration);
                        message = message.replace(/\$\{coupon_off\}/, coupon_off);
                        message = message.replace(/\$\{price_discount\}/, price_discount);
                        message = message.replace(/\$\{price\}/, price_normal);
                        message = message.replace(/:duration/, duration);
                        message = message.replace(/:coupon_off/, coupon_off);
                        message = message.replace(/:price_discount/, price_discount);
                        message = message.replace(/:price/, price_normal);

                        // console.error('messages:', { message_new: message_new, message: message })

                        // console.log('message?', {
                        //     message: message,
                        //     duration: duration,
                        //     coupon_off: coupon_off,
                        //     price_discount: price_discount,
                        //     price_normal: price_normal,
                        //     'price.stripe': JSON.parse(JSON.stringify(price.stripe)),
                        // });
                    }

                    // console.debug('NEW LABEL:', { message: message, message_new: message_new });
                    labels[price.stripe['id']] = message;


                }
            }
        }

        // updateSubscription('label', labels[form.lookup_key]);
        // console.error('buildLabels', locale.value, getActiveLanguage(), JSON.parse(JSON.stringify(labels)));

        let lang = getActiveLanguage();
        if (locale.value != lang) {
            loadLanguageAsync(locale.value);
            // loadLanguage(locale.value);
            console.error('loadLanguageAsync?', locale.value, lang);

            // TOFIX Language need time to be loaded, why?
            // @see bottom watch locale.value|labels[form.lookup_key]
            setTimeout(() => {
                buildLabels();
            }, 70);
        }

        // console.debug('CheckoutForm.buildLabels()', {
        //     // 'offering.value': offering.value && offering.value.packages && offering.value.packages.items
        //     //     ? JSON.parse(JSON.stringify(offering.value.packages.items))
        //     //     : null,
        //     // 'show_stripe_offers': show_stripe_offers.value,
        //     'coupon': coupon
        //         ? JSON.parse(JSON.stringify(coupon))
        //         : null,
        //     'labels': JSON.parse(JSON.stringify(labels)),
        // });

    }, 70); // !nextTick
};

const prices = reactive({});
export const sortable = reactive({});
export const buildPrices = () => {

    if (!offering.value || !offering.value.packages) {
        // console.warn('CheckoutForm.buildPrices()', {
        //     offering: JSON.parse(JSON.stringify(offering.value))
        // });

        goToStep(1);

        return false;
    }

    for (var z in prices) delete prices[z];
    Object.assign(prices, {});
    Object.assign(sortable, {});

    // console.debug('CheckoutForm.buildPrices()', JSON.parse(JSON.stringify(prices)), Object.keys(offering.value.packages.items), Object.keys(offering.value.packages.items));

    for (var k of Object.keys(offering.value.packages.items)) {

        var item = offering.value.packages.items[k];

        // console.error('item', JSON.parse(JSON.stringify(item)));

        for (var price of item.products.items) {
            // console.error('typeof price.stripe', typeof price.stripe);
            if (typeof price.stripe != 'undefined') {
                // console.log('item', JSON.parse(JSON.stringify(item)));
                var key = price.stripe['id'];
                price.position = item.position;
                prices[key] = JSON.parse(JSON.stringify(price));
            }
            // else {
            //     console.error('price', JSON.parse(JSON.stringify(price)));
            // }
        }
    }

    sortable.value = Object.fromEntries(
        Object.entries(prices).sort(([, a], [, b]) => {
            // return a.stripe.unit_amount - b.stripe.unit_amount;
            return a.position - b.position
        })
    );
};

export const priceRecurringIntervalToFr = (count, interval, short) => {

    // TODO: 'apples' => '{0} There are none|{1} There is one|[2,*] There are :count',

    // var translations = {
    //     'month': 'mois',
    //     'day': 'jour',
    //     'jour': 'jour', //?
    //     'week': 'semaine',
    //     'year': 'an',
    // };

    // if (translations[interval]) {
    //     interval = translations[interval];
    // }

    // console.error('priceRecurringIntervalToFr()', [interval])

    if (short) {
        if (count > 1) {
            // if (interval[interval.length - 1] != 's') {
            //     interval += 's';
            // }

            // return `tous les ${count} ${interval}`;
            return trans('Tous les :count :interval', { count: count, interval: transChoice(`durations.${interval}`, count) });
        }

        // return `par ${interval}`;
        return trans(`par :interval`, { interval: transChoice(`durations.${interval}`, count) });
    }

    if (count > 1) {
        // if (interval[interval.length - 1] != 's') {
        //     interval += 's';
        // }

        // return `Tous les ${count} ${interval}`;
        return trans('Tous les :count :interval', { count: count, interval: transChoice(`durations.${interval}`, count) });
    }

    // if (interval[interval.length - 1] != 's') {
    //     interval += 's';
    // }

    // return `Tous les ${interval}`;
    return trans('Tous les :interval', { interval: transChoice(`durations.${interval}`, 2) });
};

export const getDuration = (s) => {

    var k = null;
    var durations = window.durations;

    var duration = null;
    if (!duration && durations[s.metadata.duration]) {
        k = s.metadata.duration;
        duration = durations[s.metadata.duration];
    }
    if (!duration && durations[s.lookup_key]) {
        k = s.lookup_key;
        duration = durations[s.lookup_key];
    }
    if (!duration && durations[s.id]) {
        k = s.id;
        duration = durations[s.id];
    }
    if (!duration && s.recurring && s.recurring.interval) {
        // k = s.recurring.interval;
        // k = s.recurring.interval_count + '' + s.recurring.interval[0];
        // duration = durations[s.recurring.interval];

        if (s.recurring.interval_count <= 1) {
            k = 'par :interval';
            duration = trans(k, { interval: transChoice(`durations.${s.recurring.interval}`, s.recurring.interval_count) })
        } else {
            k = 'tous les :count :interval';
            duration = trans(k, { count: s.recurring.interval_count, interval: transChoice(`durations.${s.recurring.interval}`, s.recurring.interval_count) });
        }

        // console.error('trans duration?', {
        //     s: JSON.parse(JSON.stringify(s)),
        //     k: k,
        //     k2: `durations.${s.recurring.interval}`,
        //     duration: duration,
        //     interval_count: s.recurring.interval_count,
        //     interval: s.recurring.interval,
        //     // k: k,
        //     // trans: trans(`durations.${k}`)
        // });

        return duration;
    }

    // if (!duration) {
    //     console.debug('duration is missing? (3)', JSON.parse(JSON.stringify(s)));
    // }

    // console.debug('duration is missing? (3)', JSON.parse(JSON.stringify(duration)));

    // if (k == '*'
    //     || duration == '200 ans'
    // ) {
    // durations.*?
    //     duration = trans('à vie');
    // }

    let translated = k ? trans(`durations.${k}`) : null;

    return translated ? translated : duration;
};

export const defaultLookupKey = () => {

    if (/\.checkout$/.test(route().current())) {
        if (!form.lookup_key && checkout_price_id.value) {
            console.error('!lookup_key && checkout_price_id', {
                checkout_price_id: checkout_price_id.value,
                'keys(offering.value.packages.items)': Object.keys(offering.value.packages.items),
                sortable: JSON.parse(JSON.stringify(sortable.value)),
                'sortable.length': Object.values(sortable.value).length
            });

            if (Object.values(sortable.value).length == 0) {
                // Offer checkout_price_id doesn't exists.
                form.lookup_key = null;

                // setCheckoutPriceId(null);
                checkout_price_id.value = null;

                resetCheckout()

            } else {
                form.lookup_key = checkout_price_id.value;
            }
        }
    }

    // console.debug('CheckoutForm.defaultLookupKey()', {
    //     lookup_key: form.lookup_key,
    //     href: window.location.href,
    //     has_local_coupon: has_local_coupon.value,
    //     has_stripe_coupon: has_stripe_coupon.value,
    //     route: route().current()
    // });

    if (!has_local_coupon.value && !has_stripe_coupon.value) {
        return false;
    }

    if (sortable.value && Object.keys(sortable.value).length > 0) {
        if (has_stripe_coupon.value) {
            if (!form.lookup_key) {
                form.lookup_key = Object.values(sortable.value)[0].stripe.id;

                // console.debug('CheckoutForm.defaultLookupKey', form.lookup_key, JSON.parse(JSON.stringify(Object.values(sortable.value)[0])));
            }
        }
        if (Object.keys(sortable.value).length == 1) {
            for (var z in prices) {
                var price = prices[z];
                if (price.stripe['id'] == stripe_price_id.value || Object.keys(labels).length == 1) {
                    form.lookup_key = price.stripe['id'];
                    break;
                }
            }
        }
    }

    // console.debug('CheckoutForm.defaultLookupKey()', {
    //     'form.lookup_key': form.lookup_key
    // });

    return {
        has_stripe_coupon: has_stripe_coupon.value,
        lookup_key: form.lookup_key,
        length: sortable.value ? Object.keys(sortable.value).length : null
    };
};

export const applyPromoPercent = (price, promo) => {
    return price - price / 100 * promo;
};

export const applyPromoFixe = (price, promo) => {
    return price - promo;
}

watch(() => form.lookup_key,
    (val, oldVal) => {
        if (val) {
            stripe_price_id.value = null;
            submit();
        }
    });

watch(() => locale.value,
    (val, oldVal) => {
        // console.debug('NEW LABEL:', labels[form.lookup_key]);
        if (labels[form.lookup_key]) {
            updateSubscription('label', labels[form.lookup_key]);
        }
    });

watch(() => labels[form.lookup_key],
    (val, oldVal) => {
        // console.debug('NEW LABEL:', labels[form.lookup_key]);
        if (labels[form.lookup_key]) {
            updateSubscription('label', labels[form.lookup_key]);
        }
    });